import { ReactNode, useState } from "react";
import { Dropdown } from "antd";

type ContextMenuState<DataType> = {
  isOpen: boolean,
  x?: number,
  y?: number,
  options?: string[],
  data?: DataType
};

type ContextMenuHook<DataType> = {
  open: (mouseEvent: { clientX: number, clientY: number }, data: DataType, options: string[]) => void,
  overlay: ReactNode
};

export default function useContextMenu<DataType>(
  onOptionSelected?: (data: DataType, option: string) => void
): ContextMenuHook<DataType> {
  const [contextMenu, setContextMenu] = useState<ContextMenuState<DataType>>({ isOpen: false });

  function open(mouseEvent: { clientX: number, clientY: number }, data: DataType, options: string[]) {
    if (!contextMenu.isOpen) {
      document.addEventListener("click", function onClickOffContextMenu() {
        setContextMenu({
          isOpen: false,
          data: undefined,
          options: undefined,
          x: undefined,
          y: undefined
        });
        document.removeEventListener("click", onClickOffContextMenu);
      });
    }

    setContextMenu({
      isOpen: true,
      data,
      options,
      x: mouseEvent.clientX,
      y: mouseEvent.clientY
    });
  }

  const overlay = !contextMenu.isOpen ? undefined :
    <Dropdown
      open
      menu={{
        items: contextMenu.options?.map(o => ({
          key: o,
          label: o,
          onClick: () => onOptionSelected!(contextMenu.data!, o)
        }))
      }}
      overlayStyle={{ left: contextMenu.x ?? 0, top: contextMenu.y ?? 0 }}
    />;

  return { open, overlay };
}
